import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "./ThemeContext";
import { Nav, Footer } from "./components";
import AppRoutes from "./router";
import "./index.css";

export default function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Nav />
        <AppRoutes />
        <Footer />
      </BrowserRouter>
    </ThemeProvider>
  );
}
